<template>
  <v-container>
    <v-layout>
      <v-flex xs12>
        <div id="map" class="mapStyle">
          <l-map :zoom="zoom" :center="center">
            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
            <l-geo-json
              :geojson="schoolLocation.geojson"
              :options="schoolLocation.options"
            >
            </l-geo-json>
          </l-map>
        </div>
      </v-flex>
    </v-layout>
  </v-container>    
</template>

<script>

import Vue from 'vue'

// import { icon } from 'leaflet'
import { LMap, LTileLayer, LGeoJson } from 'vue2-leaflet'
// import L from 'leaflet'

import PopupContent from './GeoJson2Popup'
import data from '@/pages/map/sample-GeoJson.js'
/*
var baseballIcon = icon({
  iconUrl: 'static/images/baseball-marker.png',
  iconSize: [32, 37],
  iconAnchor: [16, 37],
  popupAnchor: [0, -28]
})
*/
function onEachFeature (feature, layer) {
  let PopupCont = Vue.extend(PopupContent)
  let popup = new PopupCont({propsData: { data: feature.properties }})
  layer.bindPopup(popup.$mount().$el)
}

export default {
  components: {
    LMap,
    LTileLayer,
    LGeoJson
  },
  data () {
    return {
      zoom: 14,
      // center: [11.556880, 104.892486], // phnom penh
      center: [11.470450, 104.538820],    // kps
      url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',

      schoolLocation: {
        geojson: [ data.schoolLocation ],
        options: {
          style: function (feature) {
            return feature.properties && feature.properties.style
          },
          onEachFeature: onEachFeature,
          pointToLayer: function (feature, latlng) {
            return L.circleMarker(latlng, {
              radius: 8,
              fillColor: '#ff7800',
              color: '#000',
              weight: 1,
              opacity: 1,
              fillOpacity: 0.8
            })
          }
        }
      }
    }
  },
  methods: {
  }
}
/* Ref
  https://github.com/KoRiGaN/Vue2Leaflet/blob/master/examples/src/assets/geojson/sample-geojson.js
  https://github.com/KoRiGaN/Vue2Leaflet/blob/master/examples/src/components/GeoJSON2.vue
*/
</script>

<style scoped>
  .mapStyle {
    padding-top: 1.5em;
    z-index: 0;
    height: 900px;
    width: 80%;
    margin: auto;
  }
</style>
